<section class="flex flex-col w-full h-full overflow-hidden mat-drawer-container">
  <header class="flex items-center flex-none p-10 border-b border-solid border-gray-lighter lg:p-20s">
    <h2 class="m-10 text-lg font-bold">State Licenses</h2>
    <button type="button" class="m-10 ml-auto icon-button is-primary is-inverted" aria-label="Close dialog"
      [mat-dialog-close]="false"><i class="material-icons">close</i></button>
  </header>
  <section class="grid grid-cols-1 gap-20 p-20 overflow-auto max-h-640 bg-gray-50 mat-drawer-container"
    [class]="!!licenses && !!licenses.length ? 'md:grid-cols-2' : ''">
    @for (l of licenses; track l) {
      <div class="flex flex-col w-full gap-20 p-20 card">
        <header class="p-0 pb-20 border-b border-solid border-gray-lighter">
          <h2 class="text-lg heading">
            {{stateLongNameByShortName[l.State.toUpperCase()] + ' License: ' + l.LicenseNum}}
          </h2>
        </header>
        <div class="grid grid-cols-2 gap-10">
          <div class="mb-10">
            <span class="font-bold">License Class</span><br />
            {{l.LicenseClass}}
          </div>
          <div class="mb-10">
            <span class="font-bold">Lines of Authority</span>
            @for (a of l.Loas; track a; let isLast = $last) {
              <div>{{a.Loa}}{{isLast ? '' : ', '}}</div>
            }
          </div>
          <div class="mb-10">
            <span class="font-bold">Effective Date</span><br />
            {{l.LicensedOn}}
          </div>
          <div class="mb-10">
            <span class="font-bold">Expiration Date</span> <br />
            {{l.Expires}}
          </div>
        </div>
      </div>
    }@empty {
      <div>
        <p class="w-full p-40 text-center">No state licenses available.</p>
      </div>
    }
  </section>
  <div class="flex flex-none p-10 mt-auto border-t border-solid lg:p-20 border-gray-lighter">
    <button type="button" mat-button class="m-10 ml-auto button is-primary" [mat-dialog-close]="true">Close</button>
  </div>
</section>
